// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<section id="customer-loans-edit" class="box">
  <sub-header header="'Edit interest accrual'"></sub-header>

  <div class="content">
    <form name="\$ctrl.form">
      <form-section>
        <table class="table table--generate-row-ids">
          <thead>
            <th>No.</th>
            <th></th>
            <th>Outstanding accrual balance</th>
            <th>Adjustment</th>
            <th>New accrual balance</th>
          </thead>
          <tbody class="tbody">
            <tr>
              <td></td>
              <td>Accrued Interest</td>
              <td><cash ng-disabled="true" ng-model="\$ctrl.currentAccruedInterest" ignore-amount-validation="true"></cash></td>
              <td><cash ng-disabled="true" value="\$ctrl.adjustment('accruedInterest')"></cash></td>
              <td><cash min="0" required ng-model="\$ctrl.targetAccruedInterest" ng-change="\$ctrl.calculateNetCarryingAccrual()"></cash></td>
            </tr>

            <tr>
              <td></td>
              <td>
                Accrual Allowance
                <help title="Allowance will not create GL entries"></help>
              </td>
              <td><cash ng-disabled="true" ng-model="\$ctrl.currentAccrualAllowance" ignore-amount-validation="true"></cash></td>
              <td><cash ng-disabled="true" value="\$ctrl.adjustment('accrualAllowance')"></cash></td>
              <td><cash max="\$ctrl.targetAccruedInterest" name="targetAccrualAllowance" required ng-model="\$ctrl.targetAccrualAllowance" ng-change="\$ctrl.calculateNetCarryingAccrual()"></cash></td>
            </tr>

            <tr>
              <td></td>
              <td>Net</td>
              <td><cash ng-disabled="true" ng-model="\$ctrl.currentNetCarryingAccrual" ignore-amount-validation="true"></cash></td>
              <td><cash ng-disabled="true" value="\$ctrl.adjustment('netCarryingAccrual')"></cash></td>
              <td><cash min="0" required ng-model="\$ctrl.targetNetCarryingAccrual"></cash></td>
            </tr>

            <tr>
              <td></td>
              <td>Remarks</td>
              <td>
                <input required class="remarks" type="text" ng-model="\$ctrl.remarks"/>
              </td>
              <td colspan="2"></td>
            </tr>
          </tbody>
        </table>
        <div>
        </div>
        <div class="buttons">
          <button class="btn btn-warning" ng-click="\$ctrl.goBack()">Cancel</button>
          <button class="btn btn-success" ng-click="\$ctrl.save()" ng-disabled="\$ctrl.form.\$pristine || \$ctrl.form.\$invalid">Save</button>
        </div>
      </form-section>
    </form>
  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/edit/customer-loans-edit-interest-accrual.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;